import { CurrencyCodeType } from '@/types/currency';

import { CURRENCY_SYMBOL_DATA_MAP } from './constants';

export const mapCurrencyToSymbol = (currency?: CurrencyCodeType): string => {
  if (!currency) return '';

  const currencyCode = currency.toUpperCase() as CurrencyCodeType;

  return CURRENCY_SYMBOL_DATA_MAP[currencyCode]?.symbol || currencyCode;
};
